import { HTMLAttributes } from "react";
import cx from "classnames";

export const MainContainer = ({
  children,
  className,
  ...props
}: Omit<HTMLAttributes<HTMLDivElement>, "role">) => {
  return (
    <div {...props} className={cx("modal-container", className)} role="main">
      {children}
    </div>
  );
};
